import React from 'react';
import './Technology.css';
import img from '../../assets/img/l-removebg-preview.png';

import rounded2 from '../../assets/img/lll.png';
import rotate1 from '../../assets/img/rotate2.png'
import rotate2 from '../../assets/img/rotate.png'
import rotate3 from '../../assets/img/rotate3.png'
import rotate4 from '../../assets/img/rotate4.png'
import rotate5 from '../../assets/img/rotate5.png'

const industryArray=[
  {
    title:'AI & Machine Learning:',
    description:'Uncover hidden insights with intelligent automation.',
    rotation:rotate1
  },
  {
    title:'Real-Time Analytics:',
    description:'Get instant reports and forecasts for proactive decision-making.',
    rotation:rotate2
  },
  {
    title:'Scalable Solutions:',
    description:'Handle any volume of data with ease and efficiency.',
    rotation:rotate3
  },
  {
    title:'Secure & Compliant:',
    description:'Adheres to global data security standards.',
    rotation:rotate4
  },
]

function IndustrySolutions() {
  return (
    <div className="industry-body" id='industry'>
      <div className="industry-solutions-container">
        <h1 className="title">OrbiNexum Technology</h1>
        <p className="subtitle">OrbiNexum leverages state-of-the-art machine learning, AI, and cloud computing to process and analyze vast amounts of data in record time. Our platform is designed to integrate seamlessly with your existing infrastructure, delivering instant insights and ensuring business agility.
        </p>
        <div className="grid">
          {/* Card 1 */}
          {industryArray.map((industry, index) => (
            <div className="card" key={index}>
              <div className="number">{index+1}</div>
              <h2 className="card-title">{industry.title}</h2>
              <p className="card-description">
                {industry.description}
              </p>
              <img
                src={industry.rotation} 
                alt="Rotating Image"
                loading="lazy"
                className="rotate-image"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IndustrySolutions;